import {FC} from "react";
import './FlashyBorderContainer.css'

// @ts-ignore
export const FlashyBorderContainer = ({ children }) => {

  return (
    <div className={"flashy-border-container-wrapper"}>
      <div className={"flashy-border-container"}>
        {children}
      </div>
    </div>
  )
}
